import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from './../../_services/admin.service';
import { GuardianService } from './../../_services/guardian.service';


@Component({
  selector: 'app-move-student',
  templateUrl: './move-student.component.html',
  styleUrls: ['./move-student.component.css']
})
export class MoveStudentComponent implements OnInit {
  profileList=[]
  status = ""
  server_guardian_id=0
  guardian:any = undefined
  searchTemplateForm:FormGroup
  constructor(
    private adminService:AdminService,
    private activatedRoute:ActivatedRoute,
    private guardianService:GuardianService
  ) {

  }

  ngOnInit(): void {
    this.initForm()
    this.onChanges()
    this.activatedRoute.params.subscribe(
      params=>{
        this.server_guardian_id= +params['server_guardian_id']
        this.guardianService.getById(this.server_guardian_id).subscribe(
          x=>{
            this.guardian=x
          }
        )
      }
    )
  }

  initForm(){
   this.searchTemplateForm= new FormGroup(
      {'searchInput': new FormControl('')}
      )
  }


  onChanges(): void {
    this.status=""
    this.searchTemplateForm.get('searchInput').valueChanges.subscribe(val => {
      if(val.length>2){

        this.adminService.searchStudent(val,this.guardian.server_guardian_id).subscribe(
          x=>{
            this.profileList=x
          }
        )
    }else{
      this.profileList=[]
    }
  })
}

addStudent(server_profile_id:number){
  this.adminService.addStudentToGuardian(server_profile_id,this.server_guardian_id).subscribe(
    x=>{
      this.guardian=x
      this.profileList=[]
      this.status="Success"
    }
  )
}
}
